/** Strings shared by several parts of the shell and the page skeletons. */
export const common = {
    loading: "Loading…",
};
